<template>
	<div class="container">
		<div class="main_box">
			<div class="fixed_box" @click="goContact">Contact Us</div>
		</div>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			//
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		goContact() {
			let that = this;
			if(that.$route.path != '/contact') {
				that.$router.push({ path: '/contact', });
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.fixed_box{
		position: fixed;
		right: 0;
		z-index: 2;
		top: 500px;
		background-color: #0B318F;
		padding: 20px 6px 20px 6px;
		writing-mode: vertical-lr;
		transform: rotate(180deg);
		color: #ffffff;
		font-size: 18px;
		cursor: pointer;
	}
}
</style>